export default "__VITE_ASSET__C4OE1WGK__"